export enum InternalRoute{
  UI = 'ui',
  TD = 'td',
  TEST_CASE_RESULTS = 'test_case_results',
}
